import { Dispatch, SetStateAction, useContext, useEffect } from 'react'

import { ShotlistsService } from '@/services/shotlist.service'

import { ITask } from '@/types/task.interface'

import { DraftsContext } from '../components/shotlistUpload/DraftsContext'

interface IUseRestoreShotlistUploadModalParams {
	openFormModalId?: string | null
	tasks?: ITask[]
	locationState?: unknown
	setActiveModal: Dispatch<SetStateAction<string | null>>
	setActiveUploading: Dispatch<SetStateAction<string | null>>
}

export const useRestoreShotlistUploadModal = ({
	openFormModalId,
	tasks,
	locationState,
	setActiveModal,
	setActiveUploading
}: IUseRestoreShotlistUploadModalParams) => {
	const { drafts, addDraft } = useContext(DraftsContext)

	useEffect(() => {
		if (!openFormModalId) return

		sessionStorage.removeItem('openFormModal')

		const openModal = (taskId: string) => {
			setActiveModal(taskId)
			setActiveUploading(taskId)
			window.history.replaceState({}, document.title)
		}

		const draftExists = drafts.some(d => d.id === openFormModalId)

		if (draftExists) {
			openModal(openFormModalId)
		} else if (tasks) {
			const task = tasks.find(t => t.id === openFormModalId)
			if (task) {
				ShotlistsService.getShotlist(openFormModalId)
					.then(shotlist => {
						addDraft(shotlist as unknown as ITask)
						openModal(openFormModalId)
					})
					.catch(error => {
						console.error('Error creating draft from task:', error)
					})
			} else {
				window.history.replaceState({}, document.title)
			}
		}
	}, [locationState, drafts, tasks, addDraft, openFormModalId])
}
